// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiAmazoncognito as RawSiAmazoncognito } from "react-icons/si";
export const SiAmazoncognito = /* @__PURE__ */ createIcon(RawSiAmazoncognito, "SiAmazoncognito", 0);
